// @ts-strict
import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { LMHomePageUtilService } from './lm-home-page-util.service';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';
import { LMContextService } from '@app/services';
import { LMGlobalStateService } from '@states/services/lm-global-state.service';

@Component({
  selector: 'lm-home-page',
  template: `<div></div>`,
  providers: [LMHomePageUtilService]
})
export class LMHomePageComponent implements AfterViewInit {

  constructor(
    private router: Router,
    private lmHomePageUtilService: LMHomePageUtilService,
    private lmUrlUtilService: LMUrlUtilService,
    private lmContextService: LMContextService,
    private lmGlobalStateService: LMGlobalStateService
  )  {}

  ngAfterViewInit() {
    this.loadHomePageRedirect(this.router.url);
  }

  // todo combine all "getRedirectUrl" functions into a single service.
  loadHomePageRedirect(url: string) {
    // append 'output=spec' so we can retrieve the redirect url in a json format.
    url = this.lmUrlUtilService.updateUrlParams(url, { output: 'spec' });

    this.lmHomePageUtilService.getHomePageRedirect(url).subscribe(
      response => {
        // router requires a relative url, FQDN url doesn't work with navigateByUrl
        const relativeUrl = this.lmUrlUtilService.toRelativeUrl(response.redirectUrl);
        this.router.navigateByUrl(relativeUrl, { replaceUrl: true });

        //scenario: archive mode on, user clicks a menu item then select a different web app 
        //expected: when the user exits archive mode, url would be the home page of the new web app
        if (!this.lmContextService.showBreadcrumbs()) {
          const globalState = this.lmGlobalStateService.getGlobalState();
          globalState.lastClickedMenuUrl = response.redirectUrl;
          this.lmGlobalStateService.saveGlobalState(globalState);
        }
      },
      error => {
        // handle error
      });
  }

  checkSaveRequired() {
    return false;
  }

  public allowPageNavigation(): Promise<boolean> | boolean {
    return true;
  }
}
